(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gzh-card-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init(root) {
      if (!root || root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      const slides = [...root.querySelectorAll('[data-gcc-slide]')];
      const dots = [...root.querySelectorAll('[data-gcc-dot]')];
      const stage = root.querySelector('.gcc-stage');
      const count = slides.length;
      if (!count) return;
      let active = 0;
      let hovering = false;
      let pointerX = 0;
      let pointerY = 0;
      const looping = root.dataset.loop === 'true';
      const wrap = (index) => (index + count) % count;
      const relativePosition = (index) => {
        let difference = index - active;
        if (looping && count > 2) {
          if (difference > count / 2) difference -= count;
          if (difference < -count / 2) difference += count;
        }
        return difference;
      };
      function render() {
        slides.forEach((slide, index) => {
          const difference = relativePosition(index);
          const visible = Math.abs(difference) <= 2;
          const scale = difference === 0 ? 1 : Math.abs(difference) === 1 ? .82 : .68;
          const baseX = difference * (Number.parseFloat(getComputedStyle(root).getPropertyValue('--gcc-card-width')) + Number.parseFloat(getComputedStyle(root).getPropertyValue('--gcc-gap')));
          const depth = Math.abs(difference);
          const x = baseX + (hovering ? pointerX * (depth ? .34 : .1) : 0);
          const y = hovering ? pointerY * (depth ? .22 : .08) + difference * 13 : 0;
          const rotation = difference * (hovering ? 18 : 9) + (hovering ? pointerX * .018 : 0);
          slide.classList.toggle('is-active', difference === 0);
          slide.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${rotation}deg) scale(${scale})`;
          slide.style.opacity = visible ? String(difference === 0 ? 1 : Math.abs(difference) === 1 ? .62 : .32) : '0';
          slide.style.filter = difference === 0 ? 'none' : 'saturate(.65)';
          slide.style.zIndex = String(10 - Math.abs(difference));
          slide.setAttribute('aria-hidden', visible ? 'false' : 'true');
        });
        dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
      }
      function move(index) { active = looping ? wrap(index) : Math.max(0, Math.min(count - 1, index)); render(); }
      root.querySelector('[data-gcc-prev]')?.addEventListener('click', () => move(active - 1));
      root.querySelector('[data-gcc-next]')?.addEventListener('click', () => move(active + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => move(Number(dot.dataset.index))));
      slides.forEach((slide, index) => slide.querySelector('button.gcc-card')?.addEventListener('click', () => move(index)));
      root.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') { event.preventDefault(); move(active - 1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); move(active + 1); }
      });
      let pointerStart = null;
      let suppressClick = false;
      stage?.addEventListener('pointermove', (event) => {
        if (event.pointerType !== 'mouse' || !window.matchMedia('(min-width: 750px)').matches) return;
        const rect = stage.getBoundingClientRect();
        hovering = true;
        pointerX = ((event.clientX - rect.left) / rect.width - .5) * 28;
        pointerY = ((event.clientY - rect.top) / rect.height - .5) * 22;
        stage.style.setProperty('--gcc-glow-x', `${pointerX * .8}px`);
        stage.style.setProperty('--gcc-glow-y', `${pointerY * .8}px`);
        render();
      });
      stage?.addEventListener('pointerleave', (event) => {
        if (event.pointerType !== 'mouse') return;
        hovering = false;
        pointerX = 0;
        pointerY = 0;
        stage.style.setProperty('--gcc-glow-x', '0px');
        stage.style.setProperty('--gcc-glow-y', '0px');
        render();
      });
      stage?.addEventListener('pointerdown', (event) => {
        if (!window.matchMedia('(max-width: 749px)').matches || event.pointerType === 'mouse') return;
        pointerStart = { x: event.clientX, y: event.clientY };
        stage.setPointerCapture?.(event.pointerId);
      });
      stage?.addEventListener('pointerup', (event) => {
        if (!pointerStart) return;
        const distanceX = event.clientX - pointerStart.x;
        const distanceY = event.clientY - pointerStart.y;
        pointerStart = null;
        if (Math.abs(distanceX) < 35 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
        suppressClick = true;
        move(active + (distanceX < 0 ? 1 : -1));
      });
      stage?.addEventListener('pointercancel', () => { pointerStart = null; });
      stage?.addEventListener('click', (event) => {
        if (!suppressClick) return;
        event.preventDefault();
        event.stopPropagation();
        suppressClick = false;
      }, true);
      render();
    }
    function start(scope = document) { if (scope.matches?.('[data-gcc-carousel]')) init(scope); scope.querySelectorAll?.('[data-gcc-carousel]').forEach(init); }
    start();
    document.addEventListener('shopify:section:load', (event) => start(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gzh-responsive-slideshow"] && !Shopify.designMode) return;
  try {
    
  {
    class GzhResponsiveSlideshowComponent extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slideshow-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slideshow-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-slideshow-dot]'));
      this.prevButton = this.querySelector('[data-slideshow-prev]');
      this.nextButton = this.querySelector('[data-slideshow-next]');
      this.index = 0;
      this.timer = null;

      if (!this.track || this.slides.length < 1) return;

      this.prevButton?.addEventListener('click', () => this.select(this.index - 1, true));
      this.nextButton?.addEventListener('click', () => this.select(this.index + 1, true));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.select(Number(dot.dataset.index), true));
      });

      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());

      this.bindTouch();
      this.select(0, false);
      this.start();
    }

    disconnectedCallback() {
      this.stop();
    }

    bindTouch() {
      let startX = 0;
      let startY = 0;

      this.addEventListener(
        'touchstart',
        (event) => {
          startX = event.touches[0].clientX;
          startY = event.touches[0].clientY;
        },
        { passive: true }
      );

      this.addEventListener(
        'touchend',
        (event) => {
          const endX = event.changedTouches[0].clientX;
          const endY = event.changedTouches[0].clientY;
          const distanceX = endX - startX;
          const distanceY = endY - startY;

          if (Math.abs(distanceX) < 40 || Math.abs(distanceX) < Math.abs(distanceY)) return;

          this.select(this.index + (distanceX < 0 ? 1 : -1), true);
        },
        { passive: true }
      );
    }

    select(nextIndex, restart) {
      const total = this.slides.length;
      this.index = (nextIndex + total) % total;
      this.track.style.transform = `translateX(-${this.index * 100}%)`;

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === this.index;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.toggleAttribute('inert', !isActive);
      });

      this.dots.forEach((dot, dotIndex) => {
        if (dotIndex === this.index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (restart) {
        this.stop();
        this.start();
      }
    }

    start() {
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      const interval = Number(this.dataset.interval) || 5000;
      this.stop();
      this.timer = window.setInterval(() => this.select(this.index + 1, false), interval);
    }

    stop() {
      if (!this.timer) return;

      window.clearInterval(this.timer);
      this.timer = null;
    }
    }

    if (!customElements.get('gzh-responsive-slideshow-component')) {
      customElements.define('gzh-responsive-slideshow-component', GzhResponsiveSlideshowComponent);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gzh-tab-dwl"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dwil-pdp-anchor-nav')) {
    customElements.define(
      'dwil-pdp-anchor-nav',
      class DwilPdpAnchorNav extends HTMLElement {
        connectedCallback() {
          if (this.abortController) return;

          this.abortController = new AbortController();
          this.links = Array.from(this.querySelectorAll('[data-anchor-link]'));
          this.list = this.querySelector('[data-anchor-list]');
          this.extraOffset = Number.parseInt(this.dataset.extraOffset || '12', 10) || 0;
          this.targets = [];

          this.links.forEach((link) => {
            link.addEventListener('click', this.handleClick, { signal: this.abortController.signal });
          });

          window.addEventListener('resize', this.handleResize, {
            passive: true,
            signal: this.abortController.signal,
          });
          window.addEventListener('hashchange', this.handleHashChange, {
            signal: this.abortController.signal,
          });
          window.addEventListener('scroll', this.handleScroll, {
            passive: true,
            signal: this.abortController.signal,
          });
          const pageWrapper = this.closest('.page-wrapper') || document.querySelector('.page-wrapper');
          pageWrapper?.addEventListener('scroll', this.handleScroll, {
            passive: true,
            signal: this.abortController.signal,
          });
          document.addEventListener('shopify:block:select', this.handleBlockSelect, {
            signal: this.abortController.signal,
          });
          document.addEventListener('shopify:section:load', this.handleSectionLoad, {
            signal: this.abortController.signal,
          });
          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.handleDocumentReady, {
              once: true,
              signal: this.abortController.signal,
            });
          }

          this.refreshTargets();
          this.setupObserver();
          this.syncFromHash();
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.observer?.disconnect();
          window.cancelAnimationFrame(this.resizeFrame || 0);
          window.cancelAnimationFrame(this.scrollFrame || 0);
          this.abortController = null;
        }

        handleClick = (event) => {
          const link = event.currentTarget;
          const targetId = link.dataset.anchorTarget || '';
          const target = this.targets.find((entry) => entry.link === link)?.target
            || this.resolveTarget(targetId);
          if (!target) {
            event.preventDefault();
            return;
          }

          event.preventDefault();
          const scrollContainer = this.getScrollContainer();
          const targetRect = target.getBoundingClientRect();
          const offset = this.getScrollOffset();
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const behavior = reduceMotion ? 'auto' : 'smooth';

          if (
            scrollContainer
            && scrollContainer !== document.documentElement
            && scrollContainer !== document.body
          ) {
            const containerRect = scrollContainer.getBoundingClientRect();
            const top = scrollContainer.scrollTop + targetRect.top - containerRect.top - offset;
            scrollContainer.scrollTo({ top: Math.max(0, top), behavior });
          } else {
            const top = window.scrollY + targetRect.top - offset;
            window.scrollTo({ top: Math.max(0, top), behavior });
          }

          window.history.pushState(null, '', link.getAttribute('href'));
          this.setActive(link);
        };

        handleResize = () => {
          window.cancelAnimationFrame(this.resizeFrame || 0);
          this.resizeFrame = window.requestAnimationFrame(() => this.setupObserver());
        };

        handleScroll = () => {
          window.cancelAnimationFrame(this.scrollFrame || 0);
          this.scrollFrame = window.requestAnimationFrame(this.handleIntersections);
        };

        handleDocumentReady = () => {
          this.refreshTargets();
          this.setupObserver();
          this.syncFromHash();
        };

        handleSectionLoad = () => {
          this.refreshTargets();
          this.setupObserver();
          this.syncFromHash();
        };

        handleHashChange = () => {
          this.syncFromHash();
        };

        handleBlockSelect = (event) => {
          const item = event.target?.closest?.('[data-anchor-item]');
          const link = item?.querySelector?.('[data-anchor-link]');
          if (link && this.contains(link)) this.setActive(link);
        };

        resolveTarget(targetId) {
          if (!targetId) return null;

          const exactTarget = document.getElementById(targetId);
          if (exactTarget) return exactTarget;
          if (targetId !== 'dwil-reviews') return null;

          return document.querySelector(
            '#judgeme_product_reviews[data-widget-name="review_widget"], '
            + '.jdgm-review-widget[data-widget-name="review_widget"], '
            + '#judgeme_product_reviews, '
            + '.jdgm-review-widget'
          );
        }

        refreshTargets() {
          this.targets = [];

          this.links.forEach((link) => {
            const targetId = link.dataset.anchorTarget || '';
            const target = this.resolveTarget(targetId);
            const item = link.closest('[data-anchor-item]');

            if (!target) {
              link.removeAttribute('aria-current');
              if (window.Shopify?.designMode) {
                if (item) item.hidden = false;
                link.setAttribute('aria-disabled', 'true');
              } else if (item) {
                item.hidden = true;
              }
              return;
            }

            if (item) item.hidden = false;
            link.removeAttribute('aria-disabled');
            this.targets.push({ link, target, targetId });
          });

          this.hidden = this.targets.length === 0 && !window.Shopify?.designMode;
        }

        getScrollContainer() {
          const pageWrapper = this.closest('.page-wrapper') || document.querySelector('.page-wrapper');
          if (pageWrapper) {
            const overflowY = window.getComputedStyle(pageWrapper).overflowY;
            if (overflowY === 'auto' || overflowY === 'scroll') return pageWrapper;
          }

          return document.scrollingElement;
        }

        getScrollOffset() {
          const headerHeight = Number.parseFloat(
            window.getComputedStyle(document.body).getPropertyValue('--header-height')
          ) || 0;
          return headerHeight + this.getBoundingClientRect().height + this.extraOffset;
        }

        setupObserver() {
          this.observer?.disconnect();
          if (this.targets.length === 0) return;

          const offset = Math.round(this.getScrollOffset());
          const scrollContainer = this.getScrollContainer();
          const observerRoot = (
            scrollContainer
            && scrollContainer !== document.documentElement
            && scrollContainer !== document.body
          ) ? scrollContainer : null;
          this.observer = new IntersectionObserver(this.handleIntersections, {
            root: observerRoot,
            rootMargin: `-${offset}px 0px -62% 0px`,
            threshold: [0, 0.01, 0.5],
          });
          this.targets.forEach(({ target }) => this.observer.observe(target));
        }

        handleIntersections = () => {
          const offset = this.getScrollOffset();
          let current = this.targets[0];

          this.targets.forEach((entry) => {
            if (entry.target.getBoundingClientRect().top <= offset + 4) current = entry;
          });

          this.setActive(current.link);
        };

        syncFromHash() {
          const targetId = window.location.hash.replace(/^#/, '');
          const match = this.targets.find((entry) => entry.targetId === targetId);
          if (match) this.setActive(match.link);
        }

        setActive(activeLink) {
          this.links.forEach((link) => {
            if (link === activeLink) {
              link.setAttribute('aria-current', 'location');
            } else {
              link.removeAttribute('aria-current');
            }
          });

          if (!this.list || !activeLink) return;
          const left = activeLink.offsetLeft - (this.list.clientWidth - activeLink.offsetWidth) / 2;
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.list.scrollTo({ left: Math.max(0, left), behavior: reduceMotion ? 'auto' : 'smooth' });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gzh-technology-stacked-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const VERSION = 'exact-2';

    function init(root) {
      if (!root || root.dataset.gtsVersion === VERSION) return;
      root.dataset.gtsVersion = VERSION;

      const count = Number(root.dataset.count || 0);
      if (!count) return;

      const pcTrack = root.querySelector('.gts-pc-track');
      const pcImages = [...root.querySelectorAll('.gts-pc-image')];
      const dataItems = [...root.querySelectorAll('[data-gts-data]')];
      const mobileTrack = root.querySelector('[data-gts-mobile-track]');
      const mobileCards = [...root.querySelectorAll('[data-gts-mobile-card]')];
      const dots = [...root.querySelectorAll('[data-gts-dot]')];
      let currentPcState = -1;
      let currentMobile = 0;
      let pageFrame = 0;
      let mobileFrame = 0;

      function setStickyTop() {
        if (root.dataset.autoSticky !== 'true') return;
        const header = document.querySelector('#header-group') || document.querySelector('.shopify-section-group-header-group .header');
        const height = header ? Math.round(header.getBoundingClientRect().height) : 0;
        if (height > 0) root.style.setProperty('--gts-sticky-top', height + 'px');
      }

      function visiblePercent(element) {
        const rect = element.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const height = element.offsetHeight || rect.height || 1;
        return Math.max(0, Math.min(100, ((viewportHeight - rect.top) / height) * 100));
      }

      function stateForScroll(scrolled) {
        if (count === 1) return 0;
        if (count === 2) return scrolled >= 120 ? 1 : 0;
        if (count === 3) return scrolled >= 160 ? 2 : scrolled >= 120 ? 1 : 0;
        if (count === 4) return scrolled >= 170 ? 3 : scrolled >= 140 ? 2 : scrolled >= 110 ? 1 : 0;
        const start = 105;
        const step = 65 / Math.max(1, count - 2);
        return Math.max(0, Math.min(count - 1, Math.floor((scrolled - start) / step) + 1));
      }

      function stackValues(state, index) {
        if (count === 2) {
          if (state === 0) return index === 0 ? [0, 15, 1] : [0, 0, .93];
          return index === 0 ? [120, 15, 1] : [0, 0, 1];
        }
        if (count === 3) {
          const matrix = [
            [[0,20,1],[0,10,1],[0,0,.93]],
            [[120,20,1],[0,10,1],[0,0,.93]],
            [[120,20,1],[120,15,1],[0,5,1]]
          ];
          return matrix[state][index];
        }
        if (count >= 4 && index < 4) {
          const matrix = [
            [[0,29,1],[0,13,.93],[0,1,.83],[0,-6,.78]],
            [[120,29,1],[0,28,1],[0,13,.93],[0,1,.83]],
            [[120,29,1],[120,28,1],[0,28,1],[0,13,.93]],
            [[120,29,1],[120,28,1],[120,28,1],[0,28,1]]
          ];
          if (state < 4) return matrix[state][index];
        }
        if (index < state) return [120, 28, 1];
        const distance = index - state;
        const rights = [28,13,1,-6,-12,-18,-24,-30];
        const scales = [1,.93,.83,.78,.73,.68,.63,.58];
        return [0, rights[Math.min(distance, rights.length - 1)], scales[Math.min(distance, scales.length - 1)]];
      }

      function renderPcState(state) {
        if (state === currentPcState) return;
        currentPcState = state;
        pcImages.forEach((image, index) => {
          const values = stackValues(state, index);
          image.style.bottom = values[0] + '%';
          image.style.right = values[1] + '%';
          image.style.scale = String(values[2]);
        });
        dataItems.forEach((item, index) => {
          item.classList.toggle('is-active', index === state);
          item.style.top = index < state ? '-100%' : index === state ? '35%' : '100%';
          item.style.opacity = index === state ? '1' : '0';
        });
      }

      function updatePc() {
        pageFrame = 0;
        if (!pcTrack || !window.matchMedia('(min-width: 990px)').matches) return;
        if (count === 4 && CSS.supports('animation-timeline: view()')) return;
        renderPcState(stateForScroll(visiblePercent(root) * 2.2));
      }

      function mobileStep() {
        if (!mobileTrack || !mobileCards.length) return 1;
        const gap = Number.parseFloat(getComputedStyle(mobileTrack).columnGap) || 15;
        return mobileCards[0].getBoundingClientRect().width + gap;
      }

      function setMobileState(index) {
        currentMobile = Math.max(0, Math.min(count - 1, index));
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === currentMobile;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function syncMobile() {
        mobileFrame = 0;
        if (!mobileTrack) return;
        setMobileState(Math.round(mobileTrack.scrollLeft / mobileStep()));
      }

      function goMobile(index) {
        if (!mobileTrack) return;
        setMobileState(index);
        mobileTrack.scrollTo({ left: currentMobile * mobileStep(), behavior: 'smooth' });
      }

      window.addEventListener('scroll', () => {
        if (!pageFrame) pageFrame = requestAnimationFrame(updatePc);
      }, { passive: true });
      window.addEventListener('resize', () => {
        setStickyTop();
        updatePc();
        syncMobile();
      }, { passive: true });
      mobileTrack?.addEventListener('scroll', () => {
        if (!mobileFrame) mobileFrame = requestAnimationFrame(syncMobile);
      }, { passive: true });
      dots.forEach((dot) => dot.addEventListener('click', () => goMobile(Number(dot.dataset.index))));

      setStickyTop();
      renderPcState(0);
      setMobileState(0);
      updatePc();
    }

    if (!customElements.get('jmgo-technology-slider')) {
      customElements.define('jmgo-technology-slider', class extends HTMLElement {
        connectedCallback() {
          init(this);
        }
      });
    }

    function start(scope = document) {
      if (scope.matches?.('[data-gts-exact]')) init(scope);
      scope.querySelectorAll?.('[data-gts-exact]').forEach(init);
    }

    start();
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => start());
    requestAnimationFrame(() => start());
    document.addEventListener('shopify:section:load', (event) => setTimeout(() => start(event.target), 0));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
